import {useMutation} from 'react-query';
import {languageServices} from 'src/shared/services/configuration/language';

export const useGetLanguages = () => {
  return useMutation(() => {
    return languageServices.languageList();
  });
};
